'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// Redux


// Router
// Other


// Other


// Log and alert both Q `.done()` rejections _and_ unhandled errors (via polled interval)


var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _I18n = require('I18n');

var I18n = _interopRequireWildcard(_I18n);

var _UIApplication = require('UIComponents/app/UIApplication');

var _UIApplication2 = _interopRequireDefault(_UIApplication);

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _reactRedux = require('react-redux');

var _store = require('pricing-pages-unified-ui/utils/store');

var _store2 = _interopRequireDefault(_store);

var _ConfigActions = require('pricing-pages-unified-ui/actions/ConfigActions');

var _EarlyRequestExperimentActions = require('pricing-pages-unified-ui/actions/EarlyRequestExperimentActions');

var _reactRouterDom = require('react-router-dom');

var _reactRhumb = require('react-rhumb');

var _historyAdapterV = require('react-rhumb/historyAdapterV4');

var _historyAdapterV2 = _interopRequireDefault(_historyAdapterV);

var _rhumbConfig = require('../rhumb-config.yaml');

var _rhumbConfig2 = _interopRequireDefault(_rhumbConfig);

var _history = require('history');

var _Routes = require('./Routes');

var _Routes2 = _interopRequireDefault(_Routes);

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

var _usageTrackerContainer = require('usage-tracker-container');

var _ErrorPage = require('pricing-pages-unified-ui/components/ErrorPage');

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

var _params = require('hub-http/helpers/params');

var _laboratoryClient = require('laboratory-client');

var _ExperimentTreatmentSelectors = require('pricing-pages-unified-ui/selectors/ExperimentTreatmentSelectors');

var _handlers = require('q/js/handlers');

var _isThenable = require('q/js/lib/isThenable');

var _isThenable2 = _interopRequireDefault(_isThenable);

var _PurchaseMotionActions = require('pricing-pages-unified-ui/actions/PurchaseMotionActions');

var _PublicMetaDataActions = require('pricing-pages-unified-ui/actions/public-only/PublicMetaDataActions');

var _PublicAuthApi = require('pricing-pages-unified-ui/api/public-only/PublicAuthApi');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(0, _handlers.logQPromiseIssuesAndSendAlerts)();

var dispatch = _store2.default.dispatch;

// Actions for bootstrapping

var whenIdle = function whenIdle(cb) {
  if (window.hasOwnProperty('requestIdleCallback')) {
    window.requestIdleCallback(cb);
  } else {
    setTimeout(cb, 0);
  }
};

var App = function () {
  function App(config) {
    _classCallCheck(this, App);

    this.config = config;
  }

  // Kicks off the app. This is intentionally not in the constructor.


  _createClass(App, [{
    key: 'start',
    value: function start() {
      var _this = this;

      console.log('PublicApp#start(), config: ', this.config);

      (0, _usageTrackerContainer.setPrimaryTracker)(this.config.tracker);

      dispatch({
        type: _ActionTypes2.default.AUTH_STATE_RECEIVED,
        payload: this.config.authType
      });

      var history = (0, _history.createBrowserHistory)({
        basename: this.config.rootUrl
      });
      var bootstrapBlockingPromises = this.fetchBootstrapBlockers(history);
      _q2.default.Promise.all([].concat(_toConsumableArray(bootstrapBlockingPromises), [I18n.Info])).then(function () {
        _this.startRouter(history);
        _this.trackRedirectableUsers();
      }).catch(function (error) {
        // We chain our bootstrapping code with this catch
        // so we can show an Error screen rather than just a blank page
        // A side effect of this is that any errors that bubble up here
        // would be swallowed up unless we re-throw.
        _this.startRouter(history, true);
        _Raven2.default.captureMessage('Failed to bootstrap public app', {
          extra: { error: error }
        });
        _this.trackRedirectableUsers();
      });
    }
  }, {
    key: 'trackRedirectableUsers',
    value: function trackRedirectableUsers() {
      var _this2 = this;

      whenIdle(function () {
        (0, _PublicAuthApi.fetchAuth)().then(function () {
          _this2.config.tracker.track('pageView', {
            screen: 'public redirect',
            subscreen: 'authed'
          });
        }).catch(function () {
          _this2.config.tracker.track('pageView', {
            screen: 'public redirect',
            subscreen: 'unauthed'
          });
        });
      });
    }
  }, {
    key: 'fetchBootstrapBlockers',
    value: function fetchBootstrapBlockers(history) {
      if (!history) {
        throw new Error('cannot bootstrap without history');
      }
      var promises = [];

      this.config.blockingRequests.forEach(function (blockingCall) {
        /*
         * Potential return value(s) of a blockingCall() include:
         *
         *   1. A promise
         *   2. A thunk action creator
         */
        var promise = blockingCall();

        // Non-promises assumed to be thunk action creators
        if (!(0, _isThenable2.default)(promise)) {
          // Wrap in dispatch for thunk middleware to take effect
          promise = dispatch(promise);
        }

        promises.push(promise);
      });

      promises.push(dispatch((0, _ConfigActions.storeEnvironmentConfig)(this.config)));
      promises.push(dispatch((0, _PublicMetaDataActions.fetchPublicMetaData)()));
      promises.push(dispatch((0, _EarlyRequestExperimentActions.fetchExperimentTreatmentsFromEarlyRequest)('webpp002-early-request'))); // Temporary experiment blocking call

      return promises;
    }
  }, {
    key: 'fetchPricingAndPurchasingData',
    value: function fetchPricingAndPurchasingData() {
      var promises = [];
      promises.push(dispatch((0, _PurchaseMotionActions.fetchPurchaseMotionData)(this.config.getMerchandiseCatalog)));
      return promises;
    }
  }, {
    key: 'startRouter',
    value: function startRouter(history) {
      var hasError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.fetchPricingAndPurchasingData();

      /**
        WEBPP002
      **/
      var parsedParams = (0, _params.parse)(window.location.search.substring(1));
      // On Sep 4 the query param will change from ?gotest=true -> ?source=nav
      var isEligibleForWEBPP002 = parsedParams.source && parsedParams.source === 'nav' || parsedParams.gotest;

      var treatmentKey = 'monetization-webpp002';
      var parameterKey = 'default-page';

      if (isEligibleForWEBPP002) {
        var treatment = (0, _ExperimentTreatmentSelectors.experimentTreatmentSelector)(_store2.default.getState(), treatmentKey);
        // Experiment should NOT auto log exposure, manually do it here
        (0, _laboratoryClient.logExposure)(treatment, window.__HUBSPOT_UTK);
      }

      var webpp002ParamValue = (0, _ExperimentTreatmentSelectors.experimentParameterSelector)(_store2.default.getState(), treatmentKey, parameterKey).value;
      if (isEligibleForWEBPP002 && webpp002ParamValue === 'crm') {
        // hubspot.com nav pricing link goes to /pricing/marketing, so replace to CRM if in the variant
        history.replace('/crm');
      }
      //////////////////////

      (0, _reactDom.render)(_react2.default.createElement(
        _UIApplication2.default,
        {
          name: 'pricing-pages-unified-ui',
          className: 'public-pricing-page'
        },
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: _store2.default },
          _react2.default.createElement(
            _reactRhumb.RhumbProvider,
            { history: (0, _historyAdapterV2.default)(history), config: _rhumbConfig2.default },
            _react2.default.createElement(
              _reactRouterDom.Router,
              { history: history },
              hasError ? _react2.default.createElement(_ErrorPage2.default, null) : _react2.default.createElement(_Routes2.default, {
                defaultRoute: {
                  search: history.location.search,
                  pathname: this.config.defaultHubRoute
                }
              })
            )
          )
        )
      ), document.getElementsByClassName('page')[0]);
    }
  }]);

  return App;
}();

exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/PublicApp.js
// module id = 875
// module chunks = 4